export const DEBUG_SHOW_STEP_BRANCH_INPUTS = 'funnelsFlow.showStepBranchIndexInputs';

export const DEBUG_ELK_USE_INTERACTIVE_NODE_STRATEGY = 'funnelsFlow.useInteractiveNodeStrategy';

export const DEBUG_REACT_FLOW_USE_SMOOTH_STEP_PATH = 'funnelsFlow.useSmoothStepPath';

export const DEBUG_USE_NEW_FIELD_NESTED_SELECTOR = 'global.useNewFieldsNestedSelector';

export const DEBUG_USE_DAGRE_AUTO_LAYOUT = 'funnelsFlow.useDagreAutoLayout';
